module.exports = __webpack_public_path__ + "img/shield.c87e8944.svg";